export const allowedExtensions = /\.(jpe?g|hei[cf]|webp|png|pdf|doc|docx|csv|xls|xlsx)$/i;
